"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSeedsVecSerializer = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
function getSeedsVecSerializer() {
    return (0, serializers_1.struct)([['seeds', (0, serializers_1.array)((0, serializers_1.bytes)({ size: (0, serializers_1.u32)() }))]], {
        description: 'SeedsVec',
    });
}
exports.getSeedsVecSerializer = getSeedsVecSerializer;
//# sourceMappingURL=seedsVec.js.map